import type { TFunction } from "i18next";
import U2000InfoDialog from "../../../../u2000Core/components/dialog/U2000InfoDialog";

// Typage des props du composant
interface U2103UserShowSecretKeyDlgProps {
  isDialogSecretKeyOpen: boolean;
  secretKey: string;
  onClose: () => void;

  t: TFunction;
  NS: string;
}

function U2103UserShowSecretKeyDlg({ isDialogSecretKeyOpen, secretKey, onClose, t, NS }: U2103UserShowSecretKeyDlgProps) {
  if (!isDialogSecretKeyOpen) return null;

  return (
    <U2000InfoDialog width="medium" isOpen={isDialogSecretKeyOpen} title={`${t("lblUser", { ns: NS })} - ${t("lblSecretKey", { ns: NS })}`} onClose={onClose}>
      <div className="flex min-h-[48px]  items-center justify-center rounded-sm bg-gray-400 m-4 text-center text-lg font-semibold text-gray-800">{secretKey}</div>
    </U2000InfoDialog>
  );
}

export default U2103UserShowSecretKeyDlg;
